/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Composables
import { createVuetify } from 'vuetify';
import { useLocalStorage } from '@vueuse/core';
// import types
import SettingsLocalStorage from '@/constants/SettingsLocalStorage';
import Themes from '@/enums/Themes';

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: useLocalStorage(SettingsLocalStorage, {
      theme: Themes.LIGHT,
    }).value.theme,
  },
});
